import { BaseCrudService } from "@/services/base";
import { Team, User } from "@/swagger/models";
import { AxiosRequestConfig } from "axios";

class TeamService extends BaseCrudService<Team> {
    constructor() {
        super({
            apiPrefix: "teams",
            entityName: "team",
        });
    }

    async getUsers(teamId: number, axiosOptions?: AxiosRequestConfig): Promise<User[]> {
        try {
            const res = await this.axios.get<User[]>(`/${teamId}/users`, axiosOptions);
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not retrieve users for team: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    async addUser(
        teamId: number,
        userId: number,
        axiosOptions?: AxiosRequestConfig,
        successMessage: boolean = true,
    ): Promise<void> {
        try {
            const res = await this.axios.post(`/${teamId}/users/${userId}`, axiosOptions);
            if (successMessage) this.tosti.success({ message: `User successfully added to team` });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not add user to team: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    async removeUser(teamId: number, userId: number, axiosOptions?: AxiosRequestConfig): Promise<void> {
        try {
            const res = await this.axios.delete(`/${teamId}/users/${userId}`, axiosOptions);
            this.tosti.success({ message: `User successfully removed from team` });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not remove user from team: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    build(fields: Partial<Team> & Pick<Team, "customerId">): Team {
        return {
            name: "New team",
            ...fields,
        };
    }
}

export const teamService = new TeamService();
